import { gql } from '@apollo/client';

const GET_PARCEL_DATA_AND_PROPERTY_CONTACTS_BY_APN = gql`
  query getParcelDataAndPropertyContactsByApn(
    $regionId: String!
    $apn: String!
  ) {
    getParcelDataAndPropertyContactsByApn(regionId: $regionId, apn: $apn) {
      ... on PropertyContacts {
        parcelData {
          apn
          state
          county
          city
          propertyAddress
          ownerName
          ownerAddress
          bedrooms
        }
        licenseData {
          bedrooms
        }
        activeLicenseContacts {
          licenseNumber
          personType
          name
          email
          address
          phone
        }
      }

      ... on ErrorMessage {
        errorMessage
      }
    }
  }
`;

export default GET_PARCEL_DATA_AND_PROPERTY_CONTACTS_BY_APN;
